import {AssigneeGroup} from '@/web-components';
import React from 'react';

export default ({assignees}) => (
	<AssigneeGroup hideCountFrame alignStart iconSpaceBetween={4} showCount={3} assignees={assignees || []} />
);
